import { Textarea, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from '@cian/newbuilding-utils';

import { setConsRating } from '../../../actions/newReview';
import { TextareaReview } from '../../../components/NewReviewModal/parts/NewReviewModalReview/parts/Textarea';
import { getCons } from '../../../selectors/newReview';
import { REVIEWS_PROS_AND_CONS_MAX_LENGTH } from '../../../constants/reviews';

export const ConsContainer = () => {
  const dispatch = useDispatch();
  const initialValue = useSelector(getCons);
  const [value, setValue] = React.useState(initialValue);
  const [counter, setCounter] = React.useState(0);

  const setConsRatingDebounced = debounce(200, nextValue => dispatch(setConsRating(nextValue)));

  const onChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLTextAreaElement>, nextValue: string) => {
      const counter = nextValue.length;
      if (counter <= REVIEWS_PROS_AND_CONS_MAX_LENGTH) {
        setCounter(nextValue.length);
        setValue(nextValue);
        setConsRatingDebounced(nextValue);
      }
    },
    [setValue, setConsRatingDebounced, setCounter],
  );

  return (
    <TextareaReview
      title="Минусы"
      textarea={
        <Textarea onChange={onChange} value={value} minRows={5} maxRows={8} placeholder="Долго выезжать с парковки" />
      }
      counter={<UIText3 color="gray40_100">{`${counter}/${REVIEWS_PROS_AND_CONS_MAX_LENGTH}`}</UIText3>}
    />
  );
};
